class Concatenate_Strings {
    static path = 'modifiers/concatenate-strings';

    constructor(mutator){
        this.bgcolor = '#e7b3f3';
        this.title = 'A+B+C+D+E';
        this.desc = 'Add text together';

        this.addInput("A", "string,number");
        this.addInput("B", "string,number");
        this.addInput("C", "string,number");
        this.addInput("D", "string,number");
        this.addInput("E", "string,number");
        this.addOutput("Result", "string");
    }

    onConnectionsChange(type) {
        let title = 'Add ';
        title = this.inputs[0].link ? title+'A+' : title;
        title = this.inputs[1].link ? title+'B+' : title;
        title = this.inputs[2].link ? title+'C+' : title;
        title = this.inputs[3].link ? title+'D+' : title;
        title = this.inputs[4].link ? title+'E+' : title;
        title = title.slice(0, -1);

        this.title = title;
    }

}

module.exports = Concatenate_Strings
